let currentLocation: any = null;

export function setGlobalLocation(location: any) {
  currentLocation = location;
}

export function getGlobalLocation(): any {
  return currentLocation;
}